function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256,
  transform: "translate(256 256) rotate(-180)"
})), React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M224,126.75a83.79,83.79,0,0,1-26.19,60.95,26.48,26.48,0,0,0-47.49,22.42A84.07,84.07,0,0,1,59.57,151a26.47,26.47,0,0,0,1.22-52.26,84.09,84.09,0,0,1,96.37-54.23,26.13,26.13,0,0,0-1.66,9.22,26.48,26.48,0,0,0,46.93,16.82A83.69,83.69,0,0,1,224,126.75Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M208.46,53.73A26.48,26.48,0,1,1,182,27.25,26.34,26.34,0,0,1,208.46,53.73Z"
}), React.createElement("path", {
  className: "highlights",
  d: "M82.46,124.77A26.47,26.47,0,0,1,59.57,151a25,25,0,0,1-3.59.25,26.48,26.48,0,0,1,0-53,25.47,25.47,0,0,1,4.81.45A26.46,26.46,0,0,1,82.46,124.77Z"
}), React.createElement("path", {
  className: "highlights",
  d: "M202,202a26.5,26.5,0,1,1-4.19-14.28A26.49,26.49,0,0,1,202,202Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M224,126.75a83.79,83.79,0,0,1-26.19,60.95,26.48,26.48,0,0,0-47.49,22.42A84.07,84.07,0,0,1,59.57,151a26.47,26.47,0,0,0,1.22-52.26,84.09,84.09,0,0,1,96.37-54.23,26.13,26.13,0,0,0-1.66,9.22,26.48,26.48,0,0,0,46.93,16.82A83.69,83.69,0,0,1,224,126.75Z"
}), React.createElement("path", {
  className: "primary",
  d: "M208.46,53.73A26.48,26.48,0,1,1,182,27.25,26.34,26.34,0,0,1,208.46,53.73Z"
}), React.createElement("path", {
  className: "primary",
  d: "M82.46,124.77A26.47,26.47,0,0,1,59.57,151a25,25,0,0,1-3.59.25,26.48,26.48,0,0,1,0-53,25.47,25.47,0,0,1,4.81.45A26.46,26.46,0,0,1,82.46,124.77Z"
}), React.createElement("path", {
  className: "primary",
  d: "M202,202a26.5,26.5,0,1,1-4.19-14.28A26.49,26.49,0,0,1,202,202Z"
})));
var SvgSocial = function SvgSocial(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSocial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Social.a4a412d3.svg";
export { ForwardRef as ReactComponent };